export default class Microgame {
    constructor(engine) {
        this.engine = engine;
        this.container = engine.container;
        this.active = false;
        this.isPlayback = false; // When true, win/lose are no-ops (demo mode)
    }

    get primaryColor() {
        return getComputedStyle(document.documentElement).getPropertyValue('--primary-color').trim();
    }

    get secondaryColor() {
        return getComputedStyle(document.documentElement).getPropertyValue('--secondary-color').trim();
    }

    get accentColor() {
        return getComputedStyle(document.documentElement).getPropertyValue('--accent-color').trim();
    }

    start() {
        this.active = true;
        this.setup();
    }

    setup() {
        // Override this to create DOM elements
    }

    update(dt) {
        // Override this for per-frame logic
    }

    applyConfig(config) {
        // Override this to apply challenge-specific configuration (e.g., speed, targets)
        // config is an object from the challenge definition
    }

    cleanup() {
        this.active = false;
        this.container.innerHTML = ''; // Clear game layer
    }

    win() {
        if (!this.active) return;
        this.cleanup();
        this.engine.handleMicrogameResult(true);
    }

    lose() {
        if (!this.active) return;
        this.cleanup();
        this.engine.handleMicrogameResult(false);
    }
}
